import React from 'react'
import {Icon} from '@chakra-ui/react'

const HeaderRight = (props) => {
    return (
        <Icon viewBox="0 0 8 12" width="8" height="12" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.15574 0.706073C1.34727 0.546464 1.64055 0.562637 1.8108 0.742198L6.88416 6.093L2.01154 11.2569C1.84175 11.4369 1.54851 11.4537 1.35657 11.2945C1.16463 11.1353 1.14668 10.8604 1.31647 10.6805L5.64385 6.09439L1.11721 1.32019C0.946957 1.14063 0.964209 0.865682 1.15574 0.706073Z"
                fill="currentColor"
                stroke="currentColor"
                strokeLinecap="round"
            />
        </Icon>
    )
}

export default HeaderRight
